var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      attrs: { trigger: "click" },
      on: { command: _vm.handleSetLanguage }
    },
    [
      _c(
        "div",
        [
          _vm.$i18n.locale === "nl"
            ? [_c("div", [_vm._v("\n\t\t\t\tNederlands\n\t\t\t")])]
            : _vm.$i18n.locale === "en"
            ? [_c("div", [_vm._v("\n\t\t\t\tEnglish\n\t\t\t")])]
            : _vm.$i18n.locale === "fr"
            ? [_c("div", [_vm._v("\n\t\t\t\tFrançais\n\t\t\t")])]
            : [
                _c("svg-icon", {
                  attrs: {
                    "class-name": "international-icon",
                    "icon-class": "language"
                  }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c("el-dropdown-item", { attrs: { command: "nl" } }, [
            _vm._v("Nederlands")
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", { attrs: { command: "fr" } }, [
            _vm._v("Français")
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", { attrs: { command: "en" } }, [
            _vm._v("English")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }